import {GET_ROBOTS_CSV_ERROR} from "../../../reducers/robotsAndVehiclesReducer";


export const getRobotsCsvError = (error) =>{
    return {
        type: GET_ROBOTS_CSV_ERROR,
        payload: {error}
    }
}